import React, {memo} from "react"
import {KeyFilterContainer} from "./components"
import Facets from "../facets"

interface KeyFilterProps {
    name: string
}

export const KeyFilter = memo(({name}: KeyFilterProps) => (
    <KeyFilterContainer>
        <Facets facetName={name} filterName="feat" />
    </KeyFilterContainer>
))
KeyFilter.displayName = "KeyFilter"

export default KeyFilter
